export default {
    baseStyle: {
        paymentBox: {
            border: '1px solid',
            borderColor: 'gray.100',
            rounded: 'xl',
            overflow: 'hidden'
        },
        paymentButton: {
            borderRadius: '7px',
            background: 'blue.850',
            w: 'full',
            fontWeight: '500'
        },
        paymentMethodBox: {
            py: 3,
            px: [4, 4, 4],
            bg: 'gray.50',
            borderBottom: '1px solid',
            borderColor: 'gray.100'
        },
        paymentRadio: {
            '.chakra-radio__control': {
                borderRadius: '50%',
                width: '16px',
                height: '16px'
            },
            '.chakra-radio__control[data-checked]': {
                borderRadius: '50%',
                width: '16px',
                height: '16px'
            },
            '[role="radio"] > span:first-of-type': {
                borderRadius: '50%'
            },
            '[role="radio"] > span:first-of-type[data-checked]': {
                borderRadius: '50%'
            },
            'input[type="radio"]': {
                borderRadius: '50%',
                appearance: 'none',
                WebkitAppearance: 'none',
                MozAppearance: 'none'
            }
        }
    }
}
